module.exports = "./img/2f39f02f44c4f0bcb3403f2715bed77b.jpg";